import { useEffect, useRef } from 'react';
import { projectSlice } from '../../redux/ProjectSlice';
import { useAppDispatch, useAppSelector } from '../../redux/ReduxHooks';

/**
 * Clears the deploy save slot when the loaded project id changes (e.g. opening another project
 * via card, link, or share code) while keeping the slot when moving between editor, dashboard,
 * and path builder for the same project.
 */
const useSessionSaveSlotScope = () => {
  const dispatch = useAppDispatch();
  const loadedProjectId = useAppSelector((state) => state.project.loadedProject?.id ?? null);
  const previousLoadedProjectIdRef = useRef<string | null | undefined>(undefined);

  useEffect(() => {
    const previousId = previousLoadedProjectIdRef.current;
    previousLoadedProjectIdRef.current = loadedProjectId;

    if (previousId === undefined) return;

    if (previousId !== loadedProjectId) {
      dispatch(projectSlice.actions.clearSessionSaveSlot());
    }
  }, [dispatch, loadedProjectId]);
};

export default useSessionSaveSlotScope;
